import React, { useState, useEffect } from "react";
import { Input, Button } from "@fluentui/react-components";

/**
 * GlobalTableSearch - A reusable global search input for TanStack Table v8
 * @param {object} props
 * @param {string} value - The current global filter value
 * @param {function} onChange - Callback to update the global filter
 * @param {string} [placeholder] - Optional placeholder text
 * @param {number} [debounceMs] - Debounce delay in ms (default: 200)
 */
export default function GlobalTableSearch({ value, onChange, placeholder = "Search...", debounceMs = 200 }) {
    const [inputValue, setInputValue] = useState(value || "");

    useEffect(() => {
        setInputValue(value || "");
    }, [value]);

    useEffect(() => {
        // eslint-disable-next-line no-undef
        const handler = setTimeout(() => {
            if (inputValue !== value) {
                onChange(inputValue);
            }
        }, debounceMs);
        // eslint-disable-next-line no-undef
        return () => clearTimeout(handler);
    }, [inputValue]);

    return (
        <Input
            value={inputValue}
            onChange={(_, data) => setInputValue(data.value)}
            placeholder={placeholder}
            contentAfter={
                inputValue ? (
                    <Button
                        size="small"
                        appearance="subtle"
                        icon={<span style={{ fontWeight: 700 }}>&times;</span>}
                        onClick={() => setInputValue("")}
                        aria-label="Clear search"
                    />
                ) : null
            }
            style={{ maxWidth: 320 }}
        />
    );
}
